import makeStyles from '@mui/styles/makeStyles';

import { Theme } from '../../types';

const emailChipsStyles = makeStyles((theme: Theme) => {
    return {
        emailsChipStyle: {},
        wrapInputStyle: {
            padding: '4px',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center'
        },
        inputStyle: {
            // Keep the text input on the same line as the chips (compact, single
            // line) and let it fill the remaining width; the field only grows to a
            // second line once the chips themselves wrap. Without flex + minWidth
            // the input takes a full line of its own, leaving a large empty area
            // under a single chip.
            flex: 1,
            minWidth: '80px',
            width: 'auto',
            paddingLeft: '4px'
        },
        chipStyle: {
            margin: theme.spacing(0.5, 0.25)
        },
        backgroundColorPrimary: {
            backgroundColor: theme.palette.primary.lighten80
        }
    };
});

export default emailChipsStyles;
